import "antd/es/rate/style";
import _Rate from "antd/es/rate";
import withFieldWrap from '../../utils/withFieldWrap';
export default withFieldWrap(_Rate);